var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel", attrs: { id: "panel-4" } },
    [
      _c("div", { staticClass: "panel-hdr" }, [
        _c("h2", [
          _vm._v("\n\t\t\t\t" + _vm._s(_vm.__t("LIST")) + " "),
          _c("span", { staticClass: "fw-300" }, [
            _c("i", [_vm._v(_vm._s(_vm.__t("PRODUCTS")))]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-toolbar" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed",
              on: { click: _vm.create },
            },
            [_c("i", { staticClass: "fal fa-plus" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "btn btn-icon btn-sm btn-warning mr-1 shadow-0 waves-effect waves-themed",
              on: { click: _vm.create_combo },
            },
            [_c("i", { staticClass: "fal fa-plus" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "btn btn-icon btn-sm btn-outline-info shadow-0 waves-effect waves-themed mr-2",
              on: { click: _vm.remove_skip_sync },
            },
            [_c("i", { staticClass: "fal fa-money-check-edit-alt" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "btn btn-icon btn-sm btn-outline-info shadow-0 waves-effect waves-themed mr-2 ml-2",
              staticStyle: { "min-width": "200px" },
              on: { click: _vm.sync_menu },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.__t("IMPORT_MARKET_MENU")) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c("button", {
            staticClass: "btn btn-panel waves-effect waves-themed",
            attrs: {
              "data-action": "panel-fullscreen",
              "data-toggle": "tooltip",
              "data-offset": "0,10",
              "data-original-title": "Fullscreen",
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "panel-container show" }, [
        _c(
          "div",
          { staticClass: "panel-content" },
          [
            _c(
              "div",
              { staticClass: "filter_block mb-3" },
              [_c("filter_catalog")],
              1
            ),
            _vm._v(" "),
            _vm.is_load
              ? _c("b-skeleton-table", {
                  attrs: {
                    rows: this.cur_records,
                    columns: 2,
                    "hide-header": true,
                    "table-props": { bordered: false, striped: true },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.is_load
              ? _c(
                  "div",
                  { staticClass: "inbox_vue_list" },
                  [
                    _c("div", { staticClass: "org_filter" }),
                    _vm._v(" "),
                    _vm.rows.length > 0
                      ? _c(
                          "div",
                          { staticClass: "inb_pagi pt-4" },
                          [_c("sys_pagination", { key: "up" })],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.rows.length > 0
                      ? _c("b-table", {
                          staticClass:
                            "table-responsive-xl resolution_table product_list",
                          attrs: {
                            "thead-class": _vm.head_class,
                            "tbody-tr-class": _vm.rowClass,
                            items: _vm.rows,
                            fields: _vm.fields,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "table-busy",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-center text-danger my-2",
                                      },
                                      [
                                        _c("b-spinner", {
                                          staticClass: "align-middle",
                                        }),
                                        _vm._v(" "),
                                        _c("strong", [_vm._v("Working...")]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "head(id)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.is_check_all,
                                              expression: "is_check_all",
                                            },
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            disabled: true,
                                            type: "checkbox",
                                            id: "imc_checker_all",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.is_check_all
                                            )
                                              ? _vm._i(_vm.is_check_all, null) >
                                                -1
                                              : _vm.is_check_all,
                                          },
                                          on: {
                                            click: _vm.check_all,
                                            change: function ($event) {
                                              var $$a = _vm.is_check_all,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.is_check_all =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.is_check_all = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.is_check_all = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass:
                                            "custom-control-label cursor-pointer bolder",
                                          attrs: { for: "imc_checker_all" },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "head(filename)",
                                fn: function (data) {
                                  return [
                                    _c("div", {
                                      staticClass: "fs-xl text-left",
                                      domProps: {
                                        innerHTML: _vm._s(data.label),
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "head(ordering)",
                                fn: function (data) {
                                  return [
                                    _c("grid", {
                                      attrs: {
                                        list_ordering: "ordering",
                                        is_html: true,
                                        field_name: data.label,
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "head(title)",
                                fn: function (data) {
                                  return [
                                    _c("grid", {
                                      attrs: {
                                        list_ordering: "title",
                                        field_name: _vm.__t("TITLE"),
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "head(price)",
                                fn: function (data) {
                                  return [
                                    _c("grid", {
                                      attrs: {
                                        list_ordering: "price",
                                        field_name: _vm.__t("PRICE"),
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "head(uniq_id)",
                                fn: function (data) {
                                  return [
                                    _c("div", {
                                      staticClass: "fs-xl text-center",
                                      domProps: {
                                        innerHTML: _vm._s(data.label),
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "cell(id)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: data.item.published,
                                              expression: "data.item.published",
                                            },
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            name: "cid[]",
                                            type: "checkbox",
                                            id: data.item.id + "_cust_id",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              data.item.published
                                            )
                                              ? _vm._i(
                                                  data.item.published,
                                                  null
                                                ) > -1
                                              : data.item.published,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.save_product_publish(
                                                data.item
                                              )
                                            },
                                            change: function ($event) {
                                              var $$a = data.item.published,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      data.item,
                                                      "published",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      data.item,
                                                      "published",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  data.item,
                                                  "published",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass:
                                            "custom-control-label cursor-pointer bolder",
                                          attrs: {
                                            for: data.item.id + "_cust_id",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(ordering)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "b-dropdown",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "link",
                                          "toggle-class":
                                            "text-decoration-none",
                                          "no-caret": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "button-content",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary btn-icon rounded-circle position-relative js-waves-off",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fal fa-sort",
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "badge border border-light rounded-pill bg-danger-500 position-absolute pos-top pos-right",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                data.item
                                                                  .ordering
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "b-dropdown-form",
                                          { staticClass: "p-3" },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.__t("ORDERING"),
                                                  "label-for":
                                                    "dropdown-form-email",
                                                },
                                                on: {
                                                  submit: function ($event) {
                                                    $event.stopPropagation()
                                                    $event.preventDefault()
                                                  },
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "dropdown-form-email",
                                                    size: "sm",
                                                    type: "number",
                                                    placeholder:
                                                      _vm.__t(
                                                        "CHANGE_ORDERING"
                                                      ),
                                                  },
                                                  model: {
                                                    value: data.item.ordering,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        data.item,
                                                        "ordering",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "data.item.ordering",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "mt-2",
                                                    attrs: {
                                                      variant: "primary",
                                                      size: "sm",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.change_ordering(
                                                          data.item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          _vm.__t("SAVE")
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(filename)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "img_block rounded" },
                                      [
                                        _c("picture", [
                                          _c("source", {
                                            attrs: {
                                              srcset: data.item.main_photo.webp,
                                              type: "image/webp",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("source", {
                                            attrs: {
                                              srcset: data.item.main_photo.jpeg,
                                              type: "image/jpeg",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("img", {
                                            attrs: {
                                              itemprop: "image",
                                              src: data.item.main_photo.jpeg,
                                            },
                                          }),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(title)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "prod_name fs-xl" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-start w-100 fs-xl mb-2",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer hidden-md-down",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.load_preview_details(
                                                      data
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "base base-15 icon-stack-3x opacity-100 color-primary-900",
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "fal fa-indent icon-stack-1x opacity-100 color-white",
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.nice_search(
                                                    data.item.title
                                                  )
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "small text-info pl-2",
                                              },
                                              [
                                                data.item.skeep_sync
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fal fa-lock",
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "categ_name" }, [
                                      data.item.main_categ
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "small badge border border-primary text-primary",
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    data.item.main_categ.title
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      data.item.go_type
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "small badge badge-dark",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(data.item.go_type) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    data.item.product_code
                                      ? _c("div", { staticClass: "art" }, [
                                          _vm._v("\n\t\t\t\t\t\t\t\tCode : "),
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.nice_search(
                                                  data.item.product_code
                                                )
                                              ),
                                            },
                                          }),
                                        ])
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "cell(price)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "prod_price bold color-primary-900 mt-1 position-relative",
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              new Intl.NumberFormat(
                                                "ru-RU"
                                              ).format(
                                                parseFloat(data.item.price)
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        ),
                                        _c("span", {
                                          staticClass:
                                            "woocommerce-Price-currencySymbol fs-sm",
                                        }),
                                        _vm._v(" "),
                                        data.item.hasOwnProperty(
                                          "rest_price_count"
                                        ) &&
                                        parseInt(data.item.rest_price_count) > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rounded-circle js-waves-off small fs-xs",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge border border-light rounded-pill bg-danger-500 position-absolute pos-top pos-right",
                                                    staticStyle: {
                                                      top: "-5px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          parseInt(
                                                            data.item
                                                              .rest_price_count
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    data.item.price_weight > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "prod_price fs-xs color-info-900 mt-1",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  new Intl.NumberFormat(
                                                    "ru-RU"
                                                  ).format(
                                                    parseFloat(
                                                      data.item.price_weight
                                                    )
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                            _c("span", {
                                              staticClass:
                                                "woocommerce-Price-currencySymbol fs-sm",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.item.hidden_modifiers_price > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "prod_price fs-xs color-info-900 mt-1",
                                          },
                                          [
                                            _vm._v(
                                              "\n                               + " +
                                                _vm._s(
                                                  new Intl.NumberFormat(
                                                    "ru-RU"
                                                  ).format(
                                                    parseFloat(
                                                      data.item
                                                        .hidden_modifiers_price
                                                    )
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                            _c("span", {
                                              staticClass:
                                                "woocommerce-Price-currencySymbol fs-sm",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.percent_info.percent > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "prod_price fs-xs color-success-900 mt-1",
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  new Intl.NumberFormat(
                                                    "ru-RU"
                                                  ).format(
                                                    parseFloat(
                                                      data.item.final_price
                                                    )
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            ),
                                            _c("span", {
                                              staticClass:
                                                "woocommerce-Price-currencySymbol fs-sm",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "cell(uniq_id)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "text-center mt-4" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "text-center fal fa-cog width-2 cursor-pointer fs-xxl color-primary-900",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.edit(data.item)
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "row-details",
                                fn: function (row) {
                                  return [
                                    row.item.fast_preview
                                      ? _c("product_preview", {
                                          attrs: { product: row.item },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2803346408
                          ),
                        })
                      : _c("b-table"),
                    _vm._v(" "),
                    _vm.rows.length > 0
                      ? _c(
                          "div",
                          { staticClass: "inb_pagi pt-4" },
                          [_c("sys_pagination", { key: "down" })],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("product_modal"),
      _vm._v(" "),
      _c("export_modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }